<template>
  <div class="fipa-card transparent-border">
    <v-card class="fipa-card--content" :style="fullWidth ? 'width: 100%;' : ''">
      <v-card color="primary" class="fipa-card--header" flat>
        <h3
          class="fipa-card--header--title"
          :class="disableTitleHide ? 'no-white-space' : ''"
        >
          <slot name="title">{{ cutLongText(data.title, 45) }}</slot>
        </h3>
        <h4 class="fipa-card--header--subtitle">
          <slot name="subtitle">{{
            data.pubDate ? $dayjs.date(data.pubDate) : ""
          }}</slot>
        </h4>
      </v-card>

      <article>
        <slot>{{ cutLongText(data.description, 450) }}</slot>
      </article>

      <div class="mt-2">
        <hr class="primary mx-6" />
        <v-card-actions style="justify-content: flex-end" class="px-6">
          <slot name="actions">
            <v-btn
              :href="openDialog ? '' : data.link"
              :target="openNewTab ? '_blank' : '_self'"
              text
              :aria-has-pop-up="ariaHasPopUp"
              :aria-label="$t(linkBtnText)"
              color="primary"
              @click="emit(data)"
            >
              {{ $t(linkBtnText) }}
              <v-icon color="primary" small right>$iconExternalLink</v-icon>
            </v-btn>
          </slot>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "AppCard",
  props: {
    data: {
      type: Object,
      required: true
    },
    noCut: {
      type: Boolean,
      default: false
    },
    linkBtnText: {
      type: String,
      default: "common:readMore.button"
    },
    openNewTab: {
      type: Boolean,
      default: false
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    disableTitleHide: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    ariaHasPopUp: {
      type: Boolean,
      default: undefined
    }
  },
  methods: {
    emit(data) {
      if (this.openDialog) {
        this.$emit("click", { title: data.title, link: data.link });
      } else {
        this.$emit("click");
      }
    },
    cutLongText(x, num) {
      if (this.noCut) return x;
      if (!x) return "";
      if (x.length > num) {
        var foo = x.slice(0, num);
        foo = foo + "...";
        return foo;
      } else {
        return x;
      }
    }
  }
};
</script>
<style scoped>
.no-white-space {
  white-space: normal !important;
}
</style>
